const EDIT_APP_GIFTICON_DRAFT_PREFIX = 'admin:appGifticonDraft:edit:'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeStatusValue = (value, fallbackValue = 1) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// 기프티콘 상세는 운영자가 다시 선택해야 하는 판매상태만 sessionStorage에 남긴다.
export const createAppGifticonDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            status: normalizeStatusValue(params.status, 1),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 상태 검토 흐름을 이어간다.
export const applyAppGifticonDraft = ({ baseParams = {}, draft }) => {
    const normalizedBaseDraft = createAppGifticonDraftPayload({
        params: baseParams,
    })

    if (!draft) {
        return {
            params: {
                ...baseParams,
                ...normalizedBaseDraft.params,
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            status: draftParams.status === undefined
                ? normalizedBaseDraft.params.status
                : normalizeStatusValue(draftParams.status, normalizedBaseDraft.params.status),
        }
    }
}

export const createEditAppGifticonDraftKey = (goodsCode) => `${EDIT_APP_GIFTICON_DRAFT_PREFIX}${goodsCode}`

export const readAppGifticonDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppGifticonDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 검토 흐름은 그대로 유지한다.
    }
}

export const clearAppGifticonDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
